/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { SinglePartAssetUploadCompletion } from './SinglePartAssetUploadCompletion';
import {
    SinglePartAssetUploadCompletionFromJSON,
    SinglePartAssetUploadCompletionFromJSONTyped,
    SinglePartAssetUploadCompletionToJSON,
    instanceOfSinglePartAssetUploadCompletion,
} from './SinglePartAssetUploadCompletion';

/**
 * 
 * @export
 * @interface SinglePart
 */
export interface SinglePart {
    /**
     * 
     * @type {SinglePartAssetUploadCompletion}
     * @memberof SinglePart
     */
    singlePart: SinglePartAssetUploadCompletion;
}


/**
 * Check if a given object implements the SinglePart interface.
 */
export function instanceOfSinglePart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "singlePart" in value;
    return isInstance;
}

export function SinglePartFromJSON(json: any): SinglePart {
    return SinglePartFromJSONTyped(json, false);
}

export function SinglePartFromJSONTyped(json: any, ignoreDiscriminator: boolean): SinglePart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'singlePart': SinglePartAssetUploadCompletionFromJSON(json['singlePart']),
    };
}

export function SinglePartToJSON(value?: SinglePart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'singlePart': SinglePartAssetUploadCompletionToJSON(value.singlePart),
    };
}

